<template>
  <div>
    <home-title></home-title>
    <home-navigator></home-navigator>
  </div>
</template>

<script>
  import HomeTitle from './HomeTitle.vue'
  import HomeNavigator from './HomeNavigator.vue'
  export default{
    name: 'homeHeader',
//    props: ['isActive1', 'isActive2', 'isActive3', 'isActive4', 'isActive5'],
    components: {
      HomeTitle,
      HomeNavigator
    }
  }
</script>



// WEBPACK FOOTER //
// HomeHeader.vue?1dd0f827